// extracted by mini-css-extract-plugin
module.exports = {"card":"pending_card__5Fwg-","statusHeader":"pending_statusHeader__2Y6LP","stageIndustry":"pending_stageIndustry__2vp7L"};